export default __webpack_public_path__ + "static/media/Chart.e23a0ba7.svg";